<template>
  <div class="command-picker-popover" v-show="open">
    <div class="command-picker-head">
      <div class="command-picker-title">快捷命令</div>
      <span class="command-picker-count">{{ filteredCmds.length }}/{{ commands.length }}</span>
    </div>
    <div class="command-picker-search-wrap">
      <svg viewBox="0 0 24 24" fill="none" width="14" height="14"><circle cx="11" cy="11" r="7" stroke="#94a3b8" stroke-width="2"/><path d="M16.5 16.5L21 21" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/></svg>
      <input
        v-model="query"
        class="command-picker-search-input"
        type="text"
        :placeholder="'搜索命令，如 /status、new、reasoning'"
        @click.stop
      />
    </div>
    <div class="command-picker-list">
      <div v-if="commandListLoading" class="command-picker-loading">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="#d1d5db" stroke-width="3"/>
          <path d="M12 2a10 10 0 019.8 8" stroke="#5B8DEF" stroke-width="3" stroke-linecap="round">
            <animateTransform attributeName="transform" type="rotate" dur=".7s" from="0 12 12" to="360 12 12" repeatCount="indefinite"/>
          </path>
        </svg>
        <span>加载命令中...</span>
      </div>
      <template v-else>
        <button
          v-for="cmd in filteredCmds"
          :key="cmd.id || cmd.name || cmd.cmd"
          class="command-picker-item"
          type="button"
          @click.stop="select(cmd)"
        >
          <div class="command-picker-item-cmd">{{ cmdLabel(cmd) }}</div>
          <div class="command-picker-item-desc">{{ cmd.desc || cmd.description || '' }}</div>
        </button>
        <div v-if="filteredCmds.length === 0" class="command-picker-empty">暂无匹配命令</div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { commandPresets } from '../data/presets'

export default {
  name: 'CommandPickerPopover',
  props: {
    open: { type: Boolean, default: false },
    triggerRect: { default: null },
  },
  data() { return { query: '' } },
  computed: {
    ...mapState(['commandListLoading']),
    ...mapGetters(['agentCommandList']),
    commands() {
      // 优先使用接口返回的列表，否则降级为本地预设
      return this.agentCommandList.length ? this.agentCommandList : commandPresets
    },
    filteredCmds() {
      const q = (this.query || '').trim().toLowerCase().replace(/^\//, '')
      if (!q) return this.commands
      return this.commands.filter(c => {
        const label = this.cmdLabel(c).toLowerCase()
        const desc = (c.desc || c.description || '').toLowerCase()
        return label.includes(q) || desc.includes(q)
      })
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.query = ''
        this.$nextTick(() => this.applyPosition())
      }
    }
  },
  methods: {
    cmdLabel(cmd) {
      // 优先使用接口返回的 command 字段（如 /new），兼容本地预设格式
      return cmd.command || cmd.label || cmd.cmd || cmd.name || ''
    },
    select(cmd) {
      this.$emit('select', this.cmdLabel(cmd))
      this.$emit('close')
    },
    applyPosition() {
      const rect = this.triggerRect
      if (!rect || !this.$el) return
      const width = 320
      const fixedHeight = 360
      const margin = 12
      const gap = 10
      const left = Math.min(window.innerWidth - width - margin, Math.max(margin, rect.left))
      const top = Math.max(margin, rect.top - gap - fixedHeight)
      this.$el.style.left = `${left}px`
      this.$el.style.top = `${top}px`
      this.$el.style.height = `${fixedHeight}px`
    },
    handleGlobalClick(e) {
      if (this.open && !this.$el.contains(e.target)) {
        this.$emit('close')
      }
    }
  },
  mounted() {
    this.$nextTick(() => document.addEventListener('click', this.handleGlobalClick))
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleGlobalClick)
  }
}
</script>

<style scoped>
.command-picker-loading {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: 10px; padding: 32px 16px; color: #94a3b8; font-size: 13px; font-weight: 500;
}
</style>
